module.exports = __webpack_public_path__ + "static/media/thumbnail.b1c850f1.jpg";